<template>
  <div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :search="search"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:header.pessoas="{ header }">
              {{ header.text }}
              <span
                v-b-tooltip.hover.right
                title="Quantidade esperada de pessoas para a microárea."
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </template>

            <template v-slot:item.ativo="{ item }">
              {{ item.ativo == 1 ? 'Sim' : 'Não' }}
            </template>

            <template v-slot:item.acoes="{ item }">
              <div class="acoes-container">
                <v-menu offset-y left content-class="menu-acoes-microarea">
                  <template v-slot:activator="{ on, attrs }">
                    <button
                      class="btn btn-acoes-dropdown"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <i class="icofont-navigation-menu"></i>
                    </button>
                  </template>

                  <v-list dense class="menu-lista-acoes">
                    <v-list-item @click="$emit('editar', item)">
                      <v-list-item-icon>
                        <i class="icofont-pencil text-primary"></i>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Editar Microárea</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="$emit('agente-saude', item)">
                      <v-list-item-icon>
                        <i class="icofont-ui-user text-success"></i>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Agente de Saúde</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      expanded: [],
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'cnes',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'ine',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Microárea',
          align: 'start',
          filterable: true,
          value: 'nu_micro_area',
        },
        {
          text: 'Agente de saúde',
          align: 'start',
          filterable: true,
          value: 'no_profissional',
        },
        {
          text: 'Pessoas',
          align: 'start',
          filterable: true,
          value: 'estimativa_cadastro',
        },
        {
          text: 'Ativo',
          align: 'start',
          filterable: true,
          value: 'ativo',
        },
        { text: 'Ações', value: 'acoes', sortable: false, align: 'center' },
        // { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        const profissionais = JSON.parse(item.profissionais) || []

        const agenteAtivo =
          profissionais.find(
            (profissional) => Number(profissional.ativo) === 1
          ) || null

        return {
          id: index,
          ...item,
          no_profissional: agenteAtivo?.no_profissional || '-',
          cpf_profissional: agenteAtivo?.cpf_profissional || null,
          data_inicio: agenteAtivo?.data_inicio || null,
          data_fim: agenteAtivo?.data_fim || null,
        }
      })
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },
  },
}
</script>

<style lang="scss">
#administracao-microareas {
  .app-tabela {
    .acoes-container {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }

    .btn {
      border: none;
      padding: 6px 10px;
      border-radius: 6px;
      transition: all 0.2s ease;
      cursor: pointer;

      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 14px;
      }
    }

    .btn-edit {
      background-color: #e0e0e0;
      color: #333;

      &:hover {
        background-color: #d5d5d5;
      }
    }

    .btn-inativar {
      background-color: #f8d7da;
      color: #842029;

      &:hover {
        background-color: #f1b0b7;
      }
    }
  }
}
</style>
